import axios from 'axios';

const config = {
  baseURL: '/stores/async',
  timeout: 10000,
  maxRedirects: 0,
};

const postStoreDistance = (payload) => axios.post('/storeDistance-rsep', payload, config);

export default {
  postStoreDistance,
};
